export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 21a1 1 0 01-1-1V4a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1h-5.159v-6.434h2.654l.398-2.8H14.84V9.977c0-.81.248-1.363 1.528-1.363H18V6.11A23.902 23.902 0 0015.623 6C13.27 6 11.66 7.304 11.66 9.701v2.064H9v2.801h2.66V21H4z\" fill=\"#005AD9\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};